module.exports = "/_next/static/images/39a3c66576ccee41a0df345d3bd2f121-credit-card-autonomy@0.5x.png";